<template>
  <marzipano-viewer :autorotate-settings="autorotate" :options="options">
    <marzipano-minimap :active-hotspot="hotspot" :data="minimap"/>
    <marzipano-scene
      v-for="hotspot in hotspots"
      :key="hotspot.id"
      :data="hotspot"
    >
      <marzipano-floater
        v-for="link in hotspot.links"
        :key="link.id"
        :data="link"
      />
    </marzipano-scene>
  </marzipano-viewer>
</template>

<script>
import { mapGetters } from 'vuex';
import MarzipanoViewer from './MarzipanoViewer.vue';
import MarzipanoScene from './MarzipanoScene.vue';
import MarzipanoFloater from './MarzipanoFloater.vue';
import MarzipanoMinimap from './MarzipanoMinimap.vue';

export default {
  name: 'Marzipano',
  components: {
    MarzipanoViewer,
    MarzipanoScene,
    MarzipanoFloater,
    MarzipanoMinimap,
  },
  computed: {
    ...mapGetters('nativePanorama', ['options', 'hotspots', 'hotspot', 'minimap', 'autorotate']),
  },
};
</script>
